import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import SVG from 'react-inlinesvg';
import classNames from 'classnames';

import iconEmail from '../assets/images/icon_email.svg';
import iconInstagram from '../assets/images/icon_instagram.svg';
import iconVimeo from '../assets/images/icon_vimeo.svg';
import getBemClassNames from '../helpers/getBemClassNames';

const icons = {
  email: iconEmail,
  vimeo: iconVimeo,
  instagram: iconInstagram,
};

const propTypes = {
  socials: PropTypes.arrayOf(PropTypes.oneOf(['email', 'instagram', 'vimeo'])),
  className: PropTypes.string,
  showLabels: PropTypes.bool,
  childVariants: PropTypes.arrayOf(PropTypes.oneOf(['text', 'iconed', 'inverted'])),
  variants: PropTypes.arrayOf(PropTypes.oneOf(['vertical'])),
};

const defaultProps = {
  socials: [],
  className: null,
  showLabels: true,
  childVariants: ['text'],
  variants: [],
};

function SocialsList({ intl, socials, showLabels, className, variants, childVariants }) {
  const wrapperClasses = classNames(className, getBemClassNames('SocialsList', variants));
  const itemClasses = classNames(getBemClassNames('Button', childVariants));

  return (
    <div className={wrapperClasses}>
      {socials.map(social => {
        const baseHref = intl.formatMessage({ id: `socials.${social}.url` });
        const href = social === 'email' ? 'mailto:' + baseHref : baseHref;
        const targetProp = social === 'email' ? {} : { target: '_blank' };

        return (
          <a key={social} href={href} {...targetProp} className={itemClasses}>
            <SVG className="Button__icon" src={icons[social]} />
            {showLabels && intl.formatMessage({ id: `socials.${social}.label` })}
          </a>
        );
      })}
    </div>
  );
}

SocialsList.propTypes = propTypes;
SocialsList.defaultProps = defaultProps;

export default injectIntl(SocialsList);



// WEBPACK FOOTER //
// ./src/components/SocialsList.js